// extracted by mini-css-extract-plugin
export default {"root":"iiqVoEmXft3UceGeGIa_","item":"W4rWhPE2UcCBvPcA4Oi9"};